import { render, staticRenderFns } from "./organizationSettingsFees.vue?vue&type=template&id=add7405a&lang=pug"
import script from "./organizationSettingsFees.vue?vue&type=script&lang=js"
export * from "./organizationSettingsFees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports